"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EMPTY_EVENT = exports.EMPTY_EVENT = {};
var config = {};

function createConfigProvider() {
    return {
        registerEvent: function registerEvent(event, getPropTypes, buildProps) {
            config[event] = {
                getPropTypes: getPropTypes,
                buildProps: buildProps
            };
        },
        getEvent: function getEvent(event) {
            return event in config ? config[event] : EMPTY_EVENT;
        }
    };
}

var configProvider = createConfigProvider();

exports.default = configProvider;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/configProvider.js
// module id = 777
// module chunks = 0